(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dojo", [], factory);
	else if(typeof exports === 'object')
		exports["dojo"] = factory();
	else
		root["dojo"] = factory();
})(window, function() {
return 